import { useEffect, useState } from "react";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger
} from "@/components/ui/accordion";
import { api } from "@/lib/api";
import { RevealOnScroll } from "@/components/site/Reveal";

export default function FAQs() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="faqs-page" className="pt-40 pb-32">
      <div className="mx-auto max-w-[1100px] px-6 md:px-10">
        <div className="mb-16">
          <div className="overline mb-6">Frequently Asked</div>
          <RevealOnScroll
            element="h1"
            className="h-editorial text-[clamp(3rem,7vw,6rem)]"
            lines={["Everything", "you might <em>ask</em>."]}
          />
        </div>

        <Accordion type="single" collapsible data-testid="faq-accordion" className="border-t border-white/10">
          {items.map((f) => (
            <AccordionItem key={f.id} value={f.id} className="border-b border-white/10 py-2">
              <AccordionTrigger data-testid={`faq-trigger-${f.order}`} className="text-left font-display text-xl md:text-2xl hover:no-underline hover:text-[#C5A059] transition py-6">
                {f.question}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 text-base leading-relaxed pb-6 max-w-3xl">
                {f.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
}
